import parentViewTpl from './views/parentView.html';
import './profileSetting.scss';
import parentViewCtrl from './controllers/parentViewController';


const name = 'parentView';
var module = angular.module("app.parentView", [

]).component(name, {
    template: parentViewTpl,
    controllerAs: name,
    controller: parentViewCtrl
}).controller('parentViewCtrl', parentViewCtrl);

/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('parentView', {
            parent: 'app',
            url: '/parentView',
            views: {
                '@': {
                    template: parentViewTpl,
                    controller: parentViewCtrl,
                    controllerAs: 'parentView'
                }
            }
        })
}); */


// WEBPACK FOOTER //
// ./src/app/profileSetting/parentViewModule.js